import {
    useShowOnboardingWizardScreen,
    useShowOnboardingWizardScreenForScrum,
    useShowOnboardingWizardScreenForKanban,
    useShowOnboardingWizardScreenForRouteBiz
} from "../controllers";

import { checkExperimentEligibility, ExperimentKeys } from "./experiment-hooks";

export const useIsWizardVariation = ({
    updatedStatsigClientWithCloudId
}: {
    updatedStatsigClientWithCloudId: boolean;
}) => {
    const { userEligibleForWizardExperiment } = useShowOnboardingWizardScreen();
    const { userEligibleForWizardForScrumExperiment } =
        useShowOnboardingWizardScreenForScrum();
    const { userEligibleForWizardForDevKanbanExperiment } =
        useShowOnboardingWizardScreenForKanban();
    const { userEligibleForWizardForRouteBizExperiment } =
        useShowOnboardingWizardScreenForRouteBiz();

    if (!updatedStatsigClientWithCloudId) {
        return { isWizardVariation: false, withSampleData: false };
    }

    if (userEligibleForWizardExperiment) {
        return { isWizardVariation: true, withSampleData: false };
    }

    if (userEligibleForWizardForRouteBizExperiment) {
        return { isWizardVariation: true, withSampleData: false };
    }

    if (userEligibleForWizardForScrumExperiment) {
        return {
            isWizardVariation: true,
            withSampleData: false
        };
    }

    const experimentChecks: {
        isEligible: boolean;
        experimentKey: ExperimentKeys;
    }[] = [
        {
            isEligible: userEligibleForWizardForDevKanbanExperiment,
            experimentKey: "jiraProjectOnboardingWizardDevKanban"
        }
    ];
    let isWizardVariation = false;
    experimentChecks.forEach(({ isEligible, experimentKey }) => {
        if (checkExperimentEligibility(isEligible, experimentKey)) {
            isWizardVariation = true;
        }
    });
    return { isWizardVariation, withSampleData: false };
};
